export const mapContentListForCard = content => ({
  id: content.id,
  title: content.name,
  author: content.author,
  mainAuthor: content.mainAuthor,
  coAuthors: content.coAuthors,
  base: content.base,
  categoryId: content.categoryId,
  duration: content.classTotalQuantity,
  resources: content.resourceTotalQuantity,
  imageURL: content.thumbnail,
  ageRange: content.ageRange,
  keywords: content.keywords,
  secondaryAgeRange: content.secondaryAgeRange,
  novelty: content.novelty,
  activatedLanguages: content.activatedLanguages,
  completeness: content.completeness
})
